import { APP_CONFIG } from "@/config/app-config";
import { OnboardingExerciseTypePage } from "@/interface/pages/onboarding/onb-exercise-type";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute(
  "/_authenticated/users/onboarding/fourth-step"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();

  useEffect(() => {
    async function preloadNextStep() {
      const isDev = APP_CONFIG.getCurrentEnvironment() === "development";
      try {
        await router.preloadRoute({
          to: "/users/onboarding/fifth-step",
        });
      } catch (error) {
        if (isDev) {
          console.error("Error preloading next step:", error);
        }
      }
    }
    preloadNextStep();
  }, [router]);

  return <OnboardingExerciseTypePage />;
}
